import {
  Badge,
  Box,
  Button,
  ComboboxItem,
  Fieldset,
  Flex,
  Grid,
  Group,
  Paper,
  ThemeIcon,
  Textarea,
  Text,
  Select,
  TextInput,
  LoadingOverlay,
} from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconArrowBackUp,
  IconCheck,
  IconPackageExport,
  IconPackageImport,
  IconPrinter,
  IconUser,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import { repositoryMdm, repositoryPos } from "../../_base/_const/_constVar";
import { MessageResponse } from "../../model/MessageResponse";
import { TblOutwardWarrantyVendor } from "../../model/TblOutWard";
import { useForm } from "@mantine/form";
import { DatePickerInput } from "@mantine/dates";
import {
  getTblDmDeliverPrioritySelect,
  getProvinceSelectNew,
  getCommuneSelectNew,
} from "../../service/getSelectApi";
import { mapDetailToVoucherInfo } from "./serviceRepairVoucherDetail";

const ServiceRepairReturnCustomers = ({
  dataRowProps,
  handleChange,
  handleWarrantyOutward,
  id,
  typeView,
  back,
  creatorInfo,
  mode = "CREATE",
  detail,
  onPrintReturnCustomer,
}: {
  dataRowProps: any;
  handleChange: any;
  handleWarrantyOutward?: any;
  id: any;
  typeView: string;
  back: any;
  creatorInfo?: any;
  /** CREATE: lập phiếu mới. DETAIL: xem lại phiếu đã lưu, dùng chung layout, khoá nhập liệu. */
  mode?: "CREATE" | "DETAIL";
  /** Dữ liệu trả về từ API chi tiết, bắt buộc khi mode = DETAIL */
  detail?: any;
  /**
   * In phiếu xuất trả khách. CREATE: chỉ hiện nút sau khi lưu phiếu thành công.
   * DETAIL: hiện sẵn, in theo mã phiếu xuất đang xem.
   */
  onPrintReturnCustomer?: (args: {
    ids?: number[];
    outwardCode?: string;
  }) => void;
}) => {
  const isDetail = mode === "DETAIL";
  const firstItem = dataRowProps?.[0];
  const userLogin =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("userLogin") || "{}")
      : {};
  const userLoginHeader =
    typeof window !== "undefined"
      ? JSON.parse(localStorage.getItem("userLoginHeader") || "{}")
      : {};

  const entity = {
    createDate: new Date(new Date().getTime() + 7 * 3600 * 1000).toISOString(),
    createBy: Number(userLogin?.id || ""),
    customerId: null,
    customerName: null,
    invId: dataRowProps[0]?.invOrgId,
    priority: null,
    departmentId: "KHONG",
    telephoneNumber: null,
    deliveryAppointmentTime: new Date(
      new Date().getTime() + 7 * 3600 * 1000,
    )?.toISOString(),
    fromBranchAddress: null,
    customerProvinceId: null,
    customerDistrictId: null,
    customerCommuneId: null,
    customerStreetId: null,
    customerAddress: null,
    toAddress: null,
    recipientPhone: null,
    description: null,
    content: null,
  };

  const form = useForm<TblOutwardWarrantyVendor>({
    mode: "uncontrolled",
    validateInputOnChange: true,
    initialValues: {
      ...entity,
    },

    validate: {},
  });

  const [dataDeliverPriority, setDataDeliverPriority] = useState<
    ComboboxItem[]
  >([]);

  const [visible, { close, open }] = useDisclosure(false);
  const [isSaved, setIsSaved] = useState(false);

  // Form chạy ở mode "uncontrolled" nên getInputProps chỉ trả defaultValue.
  // Dữ liệu của phiếu đã lưu được nạp sau khi mount nên phải bind bằng value,
  // nếu không ô sẽ hiển thị rỗng.
  const textFieldProps = (name: string) =>
    isDetail
      ? { value: (form.getValues() as any)?.[name] ?? "" }
      : form.getInputProps(name);

  // form.setValues ở mode "uncontrolled" không tự render lại; cờ này đảm bảo
  // có đúng một lần render sau khi đã nạp xong dữ liệu phiếu.
  const [, setDetailApplied] = useState(false);

  const [isShipping, setIsShipping] = useState<boolean>(false);
  const [provinceData, setProvinceData] = useState<ComboboxItem[]>([]);
  const [communeData, setCommuneData] = useState<ComboboxItem[]>([]);

  const columnsProduct = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "itemCode",
        header: "Mã sản phẩm",
        Cell: ({ row }) => (
          <Text size="12.5px">
            {row.original.newItemCode
              ? row.original.newItemCode
              : row.original.itemCode}
          </Text>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "itemName",
        header: "Tên sản phẩm",
        Cell: ({ row }) => (
          <Text size="12.5px">
            {row.original.newItemCode
              ? row.original.newItemName || row.original.itemName
              : row.original.itemName}
          </Text>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "serial",
        header: "Serial",
        Cell: ({ row }) => (
          <Text size="12.5px">
            {row.original.newItemCode
              ? row.original.newSerial || row.original.serial
              : row.original.newSerial
                ? row.original.newSerial
                : row.original.serial}
          </Text>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "quantity",
        header: "Số lượng",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <Text size="12.5px">
            {row.original.quantity !== null &&
            row.original.quantity !== undefined
              ? row.original.quantity
              : 1}
          </Text>
        ),
      },
      {
        accessorKey: "serialStatus",
        header: "Trạng thái serial",
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: "postionCode",
        header: "Vị trí",
        Cell: ({ row }) => (
          <Text size="12.5px">
            {row.original.postionCode && row.original.positionname
              ? `${row.original.postionCode} - ${row.original.positionname}`
              : row.original.postionCode || ""}
          </Text>
        ),
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
      },
    ],
    [dataRowProps],
  );

  // const getDataRequestForm = async () => {
  //   const res = await repositoryMdm.get<MessageResponse<any>>(
  //     `/api/v1/TblWarrantyServiceRequestForm/detail?id=${id}`,
  //   );

  //   if (res && res?.success) {
  //     const result = res.data;
  //     form.setValues((prev: any) => ({
  //       ...prev,
  //       customerName: result?.custMeeting,
  //       telephoneNumber: result?.custPhone,
  //       customerProvinceId: result?.provinceId,
  //       customerDistrictId: result?.districtId,
  //       customerCommuneId: result?.communeId,
  //       customerStreetId: result?.streetId,
  //       customerAddress: result?.additionalAddress,
  //       toAddress: [result?.additionalAddress, result?.meetingAddress]
  //         .filter((i) => i && String(i).length > 0)
  //         .join(" - "),
  //     }));
  //   }
  // };

  const getDataDeliverPrioritySelect = async () => {
    const res = await getTblDmDeliverPrioritySelect();
    setDataDeliverPriority(
      res
        ?.filter((item: any) => item.value != null && item.text != null)
        ?.map((item: any) => ({
          value: item.value,
          label: item.text,
        })),
    );
  };

  // useEffect(() => {
  //   if (isDetail) return;
  //   if (id) {
  //     getDataRequestForm();
  //   }
  // }, [id, isDetail]);

  useEffect(() => {
    const fetchProvinces = async () => {
      const data = await getProvinceSelectNew();
      if (data) {
        setProvinceData(
          data
            .filter((i: any) => i.id !== undefined && i.id !== null)
            .map((i: any) => ({ value: String(i.id), label: i.name || "N/A" })),
        );
      }
    };
    fetchProvinces();
  }, []);

  useEffect(() => {
    const fetchCommunes = async () => {
      const provinceId = form.getValues().customerProvinceId;
      if (provinceId) {
        const data = await getCommuneSelectNew(String(provinceId));
        if (data) {
          setCommuneData(
            data
              .filter((i: any) => i.value !== undefined && i.value !== null)
              .map((i: any) => ({
                value: String(i.value),
                label: i.text || "N/A",
              })),
          );
        }
      } else {
        setCommuneData([]);
      }
    };
    fetchCommunes();
  }, [form.getValues().customerProvinceId]);

  // Ở chế độ xem chi tiết, thông tin người lập / khách hàng lấy từ chính phiếu đã lưu
  const effectiveCreatorInfo = React.useMemo(() => {
    if (!isDetail) return creatorInfo;
    if (!detail) return null;

    const delivery = detail.deliveryInfo ?? {};
    return {
      outwardCode: detail.transactionCode,
      employeeCode: detail.creatorCode,
      employeeName: detail.creatorName,
      departmentName: detail.departmentName,
      customerName: delivery.customerName || detail.customerName,
      customerPhone: delivery.telephoneNumber || detail.customerPhone,
      customerAddress: delivery.toAddress || detail.customerAddress,
      provinceId: delivery.customerProvinceId ?? detail.provinceId,
      communeId: delivery.customerCommuneId ?? detail.communeId,
      customerAddressDetail:
        delivery.customerAddress || detail.customerAddressDetail,
    };
  }, [isDetail, detail, creatorInfo]);

  useEffect(() => {
    if (effectiveCreatorInfo) {
      form.setValues((prev: any) => ({
        ...prev,
        customerName: effectiveCreatorInfo.customerName || prev.customerName,
        telephoneNumber:
          effectiveCreatorInfo.customerPhone || prev.telephoneNumber,
        toAddress: effectiveCreatorInfo.customerAddress || prev.toAddress,
        customerProvinceId:
          effectiveCreatorInfo.provinceId || prev.customerProvinceId,
        customerCommuneId:
          effectiveCreatorInfo.communeId || prev.customerCommuneId,
        customerAddress:
          effectiveCreatorInfo.customerAddressDetail || prev.customerAddress,
        recipientPhone:
          effectiveCreatorInfo.customerPhone || prev.recipientPhone,
      }));
    }
  }, [effectiveCreatorInfo]);

  // Phần ghi chú + giao vận chỉ có trên phiếu đã lưu (header.Attribute20)
  useEffect(() => {
    if (!isDetail || !detail) return;

    const delivery = detail.deliveryInfo ?? {};
    form.setValues((prev: any) => ({
      ...prev,
      createDate: detail.createDate ?? prev.createDate,
      description: detail.description ?? "",
      departmentId: delivery.deliveryDepartment ?? "KHONG",
      priority: delivery.priority ?? null,
      content: delivery.content ?? "",
    }));
    setDetailApplied(true);
  }, [isDetail, detail]);

  // Danh mục mức độ ưu tiên chỉ nạp khi thực sự cần hiển thị nhãn
  useEffect(() => {
    if (!isDetail || !detail?.deliveryInfo?.priority) return;
    getDataDeliverPrioritySelect();
  }, [isDetail, detail]);

  const headerRef = React.useRef<HTMLDivElement>(null);
  const formRef = React.useRef<HTMLDivElement>(null);
  const [height, setHeight] = useState(0);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const formHeight = formRef.current?.offsetHeight || 0;
    const handleResize = () => {
      // Increase offset to prevent vertical overflow and keep pagination footer visible at the bottom
      setHeight(window.innerHeight - (headerHeight + formHeight + 130));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const tableProduct = useMantineReactTable({
    columns: columnsProduct,
    data: dataRowProps,
    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,
    renderTopToolbarCustomActions: ({ table }) => <></>,
    renderToolbarInternalActions: ({ table }) => <></>,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    enableRowSelection: false,
    getRowId: (row) => row.id,
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "transactionNumber"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500",
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    enablePagination: false,
    enableBottomToolbar: false,
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  return (
    <Box
      component="form"
      mx="auto"
      onSubmit={form.onSubmit((e: TblOutwardWarrantyVendor) => {
        modals.openConfirmModal({
          title: "Xác nhận xuất trả khách",
          centered: true,
          children: (
            <div style={{ paddingBottom: 24, paddingTop: 5 }}>
              <Text size="lg" fw={600} ta="center" mb={8}>
                Bạn có chắc chắn các thông tin đã nhập là chính xác?
              </Text>
              <Text
                component="div"
                ta="center"
                size="sm"
                fs="italic"
                c="red"
                fw={500}
              >
                *Lưu ý: Phiếu xuất sẽ không thể sửa khi ấn "Đồng ý".
              </Text>
            </div>
          ),
          labels: { confirm: "Đồng ý", cancel: "Hủy" },
          onConfirm: async () => {
            open();
            try {
              const success = await handleWarrantyOutward(isShipping, e);
              if (success) setIsSaved(true);
            } finally {
              close();
            }
          },
        });
      })}
    >
      <Box ref={headerRef}>
        <Group
          justify="space-between"
          mb="xs"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
            zIndex: 10,
          }}
        >
          <Badge
            variant="gradient"
            gradient={{ from: "blue", to: "cyan", deg: 90 }}
          >
            {isDetail
              ? `Chi tiết phiếu xuất trả khách${effectiveCreatorInfo?.outwardCode ? ` - ${effectiveCreatorInfo.outwardCode}` : ""}`
              : "Xuất trả khách"}
          </Badge>
          <Flex gap="sm">
            <Button
              type="button"
              variant="default"
              size="sm"
              radius="md"
              leftSection={<IconArrowBackUp size={16} stroke={1.5} />}
              onClick={() => back(false)}
            >
              Quay lại
            </Button>
            {/* Màn chi tiết in cả phiếu; màn lập phiếu chỉ in được sau khi đã lưu */}
            {onPrintReturnCustomer && (isDetail || isSaved) && (
              <Button
                type="button"
                color="teal"
                variant="filled"
                size="sm"
                radius="md"
                leftSection={<IconPrinter size={16} stroke={1.5} />}
                onClick={() =>
                  onPrintReturnCustomer(
                    isDetail
                      ? { outwardCode: effectiveCreatorInfo?.outwardCode }
                      : {
                          ids: (dataRowProps ?? [])
                            .map((row: any) => row?.id)
                            .filter(
                              (rowId: any) =>
                                rowId !== null && rowId !== undefined,
                            ),
                        },
                  )
                }
              >
                In phiếu xuất trả
              </Button>
            )}
            {!isDetail && (
              <Button
                type="submit"
                color="blue"
                variant="filled"
                size="sm"
                radius="md"
                loading={visible}
                disabled={isSaved}
                leftSection={
                  !visible && !isSaved ? (
                    <IconCheck size={16} stroke={1.5} />
                  ) : undefined
                }
              >
                {isSaved ? "Đã lưu phiếu" : "Lưu phiếu"}
              </Button>
            )}
          </Flex>
        </Group>
      </Box>
      <LoadingOverlay
        visible={visible}
        zIndex={1000}
        overlayProps={{ radius: "sm", blur: 2 }}
      />
      <Box ref={formRef}>
        <Grid mt={5} gutter="md">
          {/* ===== CỘT 1: THÔNG TIN BÊN XUẤT ===== */}
          <Grid.Col span={{ base: 12, md: 5, lg: 5 }}>
            <Paper
              p="md"
              radius="md"
              withBorder
              style={{
                backgroundColor: "#ffffff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                height: "100%",
              }}
            >
              <Group
                gap="xs"
                mb="sm"
                pb="xs"
                style={{ borderBottom: "1px solid #f1f5f9" }}
              >
                <ThemeIcon color="blue" variant="light" size="sm" radius="sm">
                  <IconPackageExport size={16} />
                </ThemeIcon>
                <Text fw={600} size="sm" style={{ color: "#1e293b" }}>
                  Thông tin bên xuất
                </Text>
              </Group>
              <Grid gutter="xs">
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <TextInput
                    label="Số phiếu xuất"
                    size="xs"
                    value={effectiveCreatorInfo?.outwardCode || ""}
                    variant="filled"
                    readOnly
                    fw={600}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <DatePickerInput
                    label="Ngày xuất"
                    size="xs"
                    value={
                      form.getValues().createDate
                        ? new Date(form.getValues().createDate ?? "")
                        : null
                    }
                    valueFormat="DD-MM-YYYY"
                    variant="filled"
                    readOnly
                    {...form.getInputProps("createDate")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <TextInput
                    label="Tên người xuất"
                    size="xs"
                    value={
                      effectiveCreatorInfo?.employeeCode &&
                      effectiveCreatorInfo?.employeeName
                        ? `${effectiveCreatorInfo.employeeCode} - ${effectiveCreatorInfo.employeeName}`
                        : effectiveCreatorInfo?.employeeName || ""
                    }
                    variant="filled"
                    readOnly
                    leftSection={<IconUser size={14} />}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <TextInput
                    label="Phòng ban của người xuất"
                    size="xs"
                    value={effectiveCreatorInfo?.departmentName || ""}
                    variant="filled"
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <TextInput
                    label="Chi nhánh"
                    size="xs"
                    value={
                      firstItem?.invOrgCode && firstItem?.invOrgName
                        ? `${firstItem.invOrgCode} - ${firstItem.invOrgName}`
                        : firstItem?.invOrgCode || ""
                    }
                    variant="filled"
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <TextInput
                    label="Kho"
                    size="xs"
                    value={
                      firstItem?.subInvCode && firstItem?.subInvName
                        ? `${firstItem.subInvCode} - ${firstItem.subInvName}`
                        : firstItem?.subInvName || ""
                    }
                    variant="filled"
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={12}>
                  <Textarea
                    label="Ghi chú"
                    placeholder="Nhập ghi chú"
                    size="xs"
                    minRows={2}
                    autosize
                    readOnly={isDetail}
                    variant={isDetail ? "filled" : "default"}
                    {...textFieldProps("description")}
                  />
                </Grid.Col>
              </Grid>
            </Paper>
          </Grid.Col>

          {/* ===== CỘT PHẢI: THÔNG TIN KHÁCH HÀNG & GIAO VẬN ===== */}
          <Grid.Col span={{ base: 12, md: 7, lg: 7 }}>
            <Paper
              p="md"
              radius="md"
              withBorder
              style={{
                backgroundColor: "#ffffff",
                boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
                height: "100%",
              }}
            >
              <Group
                gap="xs"
                mb="sm"
                pb="xs"
                style={{ borderBottom: "1px solid #f1f5f9" }}
              >
                <ThemeIcon color="teal" variant="light" size="sm" radius="sm">
                  <IconUser size={16} />
                </ThemeIcon>
                <Text fw={600} size="sm" style={{ color: "#1e293b" }}>
                  Thông tin khách hàng & Giao vận
                </Text>
              </Group>
              <Grid gutter="xs">
                {/* --- Thông tin khách hàng --- */}
                <Grid.Col span={{ base: 12, md: 3 }}>
                  <TextInput
                    label="Tên khách hàng"
                    size="xs"
                    value={form.getValues()?.customerName ?? ""}
                    variant="filled"
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 3 }}>
                  <TextInput
                    label="Số điện thoại"
                    size="xs"
                    value={form.getValues()?.telephoneNumber ?? ""}
                    variant="filled"
                    readOnly
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 6 }}>
                  <Textarea
                    label="Địa chỉ"
                    size="xs"
                    value={form.getValues()?.toAddress ?? ""}
                    variant="filled"
                    readOnly
                    minRows={1}
                    autosize
                  />
                </Grid.Col>

                {/* --- Thông tin giao vận --- */}
                <Grid.Col span={12} mt="xs">
                  <Group
                    gap="xs"
                    pb="xs"
                    style={{ borderBottom: "1px dashed #e2e8f0" }}
                  >
                    <Text fw={600} size="xs" c="dimmed">
                      Giao vận
                    </Text>
                  </Group>
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4 }}>
                  <Select
                    label="Bộ phận giao hàng"
                    placeholder="Nhập bộ phận giao hàng"
                    size="xs"
                    disabled={isDetail}
                    data={[
                      { label: "Không", value: "KHONG" },
                      { label: "Nội bộ", value: "NOI_BO" },
                      { label: "GHTK", value: "GHTK" },
                      { label: "Nhất tín", value: "NHAT_TIN" },
                      { label: "SCA", value: "SCA" },
                      { label: "Tín thành", value: "TIN_THANH" },
                      { label: "Viettel", value: "VIETTEL" },
                      { label: "VN Post", value: "VN_POST" },
                    ]}
                    value={form.getValues().departmentId}
                    searchable
                    nothingFoundMessage={"Không tìm thấy dữ liệu !"}
                    withAsterisk
                    {...form.getInputProps("departmentId")}
                    onChange={(e) => {
                      form.setValues((prev: any) => ({
                        ...prev,
                        departmentId: e ? e : "KHONG",
                        priority: e !== "NOI_BO" ? null : prev.priority,
                      }));
                      setIsShipping(e === "NOI_BO" ? true : false);
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4 }}>
                  <Select
                    label="Độ ưu tiên"
                    placeholder="Nhập mức độ ưu tiên"
                    size="xs"
                    data={dataDeliverPriority}
                    value={
                      form.getValues().priority
                        ? form.getValues()?.priority?.toString()
                        : null
                    }
                    searchable
                    clearable
                    nothingFoundMessage={"Không tìm thấy dữ liệu !"}
                    disabled={
                      isDetail || form.getValues().departmentId === "KHONG"
                    }
                    onChange={(e) =>
                      form.setValues((prev: any) => ({
                        ...prev,
                        priority: e ? e : null,
                      }))
                    }
                    onClick={() => {
                      if (dataDeliverPriority.length === 0) {
                        getDataDeliverPrioritySelect();
                      }
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4 }}>
                  <TextInput
                    label="SĐT người nhận"
                    placeholder="Nhập SĐT"
                    size="xs"
                    readOnly={isDetail}
                    variant={isDetail ? "filled" : "default"}
                    {...textFieldProps("telephoneNumber")}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4 }}>
                  <Select
                    label="Tỉnh / Thành phố"
                    placeholder="Chọn Tỉnh/Thành phố"
                    size="xs"
                    searchable
                    clearable
                    disabled={isDetail}
                    data={provinceData}
                    value={
                      form.getValues().customerProvinceId
                        ? form.getValues().customerProvinceId?.toString()
                        : null
                    }
                    onChange={(e) => {
                      form.setValues((prev: any) => ({
                        ...prev,
                        customerProvinceId: e ? Number(e) : null,
                        customerCommuneId: null, // Reset commune when province changes
                      }));
                    }}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4 }}>
                  <Select
                    label="Quận / Huyện / Xã"
                    placeholder="Chọn Quận/Huyện/Xã"
                    size="xs"
                    searchable
                    clearable
                    data={communeData}
                    value={
                      form.getValues().customerCommuneId
                        ? form.getValues().customerCommuneId?.toString()
                        : null
                    }
                    onChange={(e) => {
                      form.setValues((prev: any) => ({
                        ...prev,
                        customerCommuneId: e ? Number(e) : null,
                      }));
                    }}
                    disabled={isDetail || !form.getValues().customerProvinceId}
                  />
                </Grid.Col>
                <Grid.Col span={{ base: 12, md: 4 }}>
                  <TextInput
                    label="Địa chỉ người nhận"
                    placeholder="Nhập địa chỉ"
                    size="xs"
                    readOnly={isDetail}
                    variant={isDetail ? "filled" : "default"}
                    {...textFieldProps("customerAddress")}
                  />
                </Grid.Col>
                <Grid.Col span={12}>
                  <Textarea
                    label="Ghi chú giao vận"
                    placeholder="Nhập ghi chú giao vận"
                    size="xs"
                    minRows={1}
                    autosize
                    readOnly={isDetail}
                    variant={isDetail ? "filled" : "default"}
                    {...textFieldProps("content")}
                  />
                </Grid.Col>
              </Grid>
            </Paper>
          </Grid.Col>
        </Grid>
      </Box>
      <Box mt={10}>
        <MantineReactTable table={tableProduct} />
      </Box>
    </Box>
  );
};

export default ServiceRepairReturnCustomers;
